import { apiRequest } from '../../shared/api/base'

// ─── Response types ─────────────────────────────────────────

export interface OnboardingStatusResponse {
  assistantProvisioned: boolean
  calendarConnected: boolean
  agent: { displayName: string; email: string | null } | null
}

export interface ProvisionAssistantResponse {
  agentId: string
  displayName: string
  email: string | null
}

export interface CheckEmailResponse {
  available: boolean
  suggestions?: string[]
}

// ─── API functions ──────────────────────────────────────────

export async function checkEmailAvailability(localPart: string): Promise<CheckEmailResponse> {
  return apiRequest<CheckEmailResponse>(`/onboarding/check-email?local=${encodeURIComponent(localPart)}`)
}

export async function getOnboardingStatus(): Promise<OnboardingStatusResponse> {
  return apiRequest<OnboardingStatusResponse>('/onboarding/status')
}

export async function provisionAssistant(
  language: string,
  firstName?: string,
  lastName?: string,
  assistantName?: string,
  signupSource?: Record<string, string>,
): Promise<ProvisionAssistantResponse> {
  return apiRequest<ProvisionAssistantResponse>('/onboarding/assistant', {
    method: 'POST',
    body: JSON.stringify({
      ...(assistantName ? { assistantName } : {}),
      language,
      firstName,
      lastName,
      ...(signupSource && Object.keys(signupSource).length > 0 ? { signupSource } : {}),
    }),
  })
}

export interface SuggestedContact {
  name: string
  context: string
  source: string
}

export async function getSuggestedContacts(): Promise<{ suggestions: SuggestedContact[] }> {
  return apiRequest<{ suggestions: SuggestedContact[] }>('/onboarding/suggested-contacts')
}

export async function saveKeyContacts(
  contacts: Array<{ name: string; context: string }>,
  peopleGoalStatus?: 'done' | 'skipped',
): Promise<{ saved: number }> {
  return apiRequest<{ saved: number }>('/onboarding/key-contacts', {
    method: 'POST',
    body: JSON.stringify({
      contacts,
      ...(peopleGoalStatus ? { peopleGoalStatus } : {}),
    }),
  })
}

export async function provisionEmail(
  emailLocal: string,
  assistantName?: string,
): Promise<{ email: string; enabled: boolean }> {
  return apiRequest<{ email: string; enabled: boolean }>('/onboarding/provision-email', {
    method: 'POST',
    body: JSON.stringify({
      emailLocal,
      ...(assistantName ? { assistantName } : {}),
    }),
  })
}
